/** Reply rate = stopped_reply enrollments / total enrollments (zelfde definitie als analytics leaderboard). */
export function audienceReplyRate(enrollments, replies) {
    if (enrollments <= 0)
        return null;
    return replies / enrollments;
}
export function formatAudienceReplyRatePct(rate) {
    if (rate == null || !Number.isFinite(rate))
        return '—';
    return `${(rate * 100).toFixed(1)}%`;
}
//# sourceMappingURL=audienceCampaignKpi.js.map